import { api, formatParams, config } from "@/utils/axios";

/**
 * 流程定义相关接口
 */

// 保存并绑定流程设计器内的xml文件
export function saveOrBindTable(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/saveOrBindTable`,
    })
  );
}

// 绑定流程表单
export function addDeployForm(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/addDeployForm`,
    })
  );
}

// 启动流程
export function flowStart(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/start/${params.procDefId}`,
    })
  );
}

// 删除流程
export function deleteFlow(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/delete/${params}`,
    })
  );
}

// 获取流程列表
export function list(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/list?pageNum=${params.pageNum}&pageSize=${params.pageSize}&emptyFlag=${params.emptyFlag}`,
    })
  );
}

// 读取xml文件
export function readXml(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/readXml/${params}`,
    })
  );
}

// 保存xml文件
export function saveXml(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/save`,
    })
  );
}

// 保存xml文件
export function getDeployForm(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/getDeployForm`,
    })
  );
}

// 指定流程办理人员列表
export function userList(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/userList`,
    })
  );
}

// 指定流程办理角色列表
export function sectionList(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/sectionList`,
    })
  );
}

/**
 * 流程任务接口相关
 */

// 我发起的流程
export function myProcess(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/myProcess?pageNum=${params.pageNum}&pageSize=${params.pageSize}&type=${params.type}`,
    })
  );
}

// 获取待办列表
export function todoList(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/todoList`,
    })
  );
}

// 获取已办任务
export function finishedList(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/finishedList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    })
  );
}

// 审批任务
export function completeProcess(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/complete`,
    })
  );
}

// 生成流程图
export function getFlowViewer(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/flowViewer/${params}`,
    })
  );
}

// 获取流程变量
export function processVariables(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/processVariables/${params}`,
    })
  );
}

// 流程历史流转记录
export function flowRecord(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/flowRecord`,
    })
  );
}

// 取消申请
export function stopProcess(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/instance/delete?instanceId=${params}`,
    })
  );
}

// 驳回任务
export function rejectProcess(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/reject`,
    })
  );
}

// 退回任务
export function returnProcess(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/return`,
    })
  );
}

// 查询可回退节点
export function returnList(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/returnList?taskId=${params}`,
    })
  );
}

/**
 * 流程扩展接口
 */

// 查询数据流转信息
export function getRecordListByDataId(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/taskfrom/getRecordListByDataId`,
    })
  );
}

// 查询数据流程信息
export function getTaskFormByDataId(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/taskfrom/getTaskFormByDataId/${params}`,
    })
  );
}

// 流程节点列表
export function getNodeList(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/getNodeList?processId=${params}`,
    })
  );
}

// 流程走线列表
export function getLineList(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/definition/getLineList?processId=${params}`,
    })
  );
}

// 所有流程
export function allProcess(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/allProcess`,
    })
  );
}

// 补录信息
export function upDateTaskCommentById(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/flowComment/upDateTaskCommentById`,
    })
  );
}

// 是否可以审批
export function whereComplete(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/flowable/task/whereComplete?dataId=${params.dataId}&tableId=${params.tableId}`,
    })
  );
}

// 任务详情
export function reqTaskDetail(id) {
  return api(
    Object.assign(formatParams("GET"), {
      url: `${config.proxy}/dynamic-form/flowable/task/flowInfoByTaskId?taskId=${id}`,
    })
  );
}
